import { Fragment, VFC } from 'react';
import { FormItemProps } from 'components/Form/FormItem';
import { OtherMeterDetailField } from './constants';
import { getOtherDetailFormItem } from './utils/getDetailFormItem';

interface OtherDetailsProps {
  itemsConfig: Partial<
    Record<
      OtherMeterDetailField,
      {
        formItemProps?: FormItemProps;
      }
    >
  >;
}

export const OtherDetails: VFC<OtherDetailsProps> = ({ itemsConfig }) => {
  return (
    <>
      {Object.entries(itemsConfig).map(([item, { formItemProps = {} }]) => (
        <Fragment key={item}>{getOtherDetailFormItem(item as OtherMeterDetailField, formItemProps)}</Fragment>
      ))}
    </>
  );
};
